<template>
  <div class="min-h-screen bg-white">
    <Head :title="`Specialisations - ${site_context_label}`" />

    <!-- Header -->
    <div class="bg-white shadow">
      <div class="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <h1 class="text-3xl font-bold tracking-tight text-gray-900">
          Our Specialisations
        </h1>
        <p class="mt-2 text-gray-600">
          {{ site_context_label }}
        </p>
      </div>
    </div>

    <!-- Specialisations Grid -->
    <div class="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
      <div v-if="specialisations.length > 0" class="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        <Link
          v-for="specialisation in specialisations"
          :key="specialisation.id"
          :href="$routes.specialisation(specialisation.slug)"
          class="group overflow-hidden rounded-lg bg-white shadow-md transition-all duration-200 hover:shadow-lg"
        >
          <div class="p-6">
            <h3 class="text-xl font-semibold text-gray-900 group-hover:text-indigo-600">
              {{ specialisation.name }}
            </h3>
            <p v-if="specialisation.description" class="mt-3 line-clamp-4 text-sm text-gray-600">
              {{ specialisation.description }}
            </p>
            <div class="mt-4 flex items-center text-sm font-medium text-indigo-600 group-hover:text-indigo-800">
              Learn more
              <svg class="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </div>
        </Link>
      </div>

      <!-- Empty State -->
      <div v-else class="py-12 text-center">
        <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
        <h3 class="mt-2 text-sm font-semibold text-gray-900">No specialisations</h3>
        <p class="mt-1 text-sm text-gray-500">
          There are no specialisations available at this time.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import Layout from '@/Layouts/Main.vue';

export default {
  components: {
    Head,
    Link,
  },
  layout: Layout,
  props: {
    specialisations: {
      type: Array,
      default: () => [],
    },
    // eslint-disable-next-line vue/prop-name-casing
    site_context: {
      type: String,
      default: null,
    },
    // eslint-disable-next-line vue/prop-name-casing
    site_context_label: {
      type: String,
      default: '',
    },
  },
};
</script>
